import React, { forwardRef, useMemo } from 'react';
import classNames from 'classnames';
import { ButtonSize } from 'components/UI_kit_3/Button/Button';
import { ReactComponent as CloseIcon } from 'assets/icons_3/x-close.svg';
import styles from './CloseButton.module.scss';

export interface ICloseButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  loading?: boolean;
  size?: ButtonSize
}

const CloseButton = forwardRef<HTMLButtonElement, ICloseButtonProps>(({
  children,
  className,
  type = 'button',
  size = 'md',
  disabled,
  loading = false,
  ...props
}, ref) => {
  const sizeClass = useMemo<string>(() => styles[`btn-${size}`], [size]);

  return (
    <button
      ref={ref}
      className={classNames(className, styles.closeBtn, sizeClass, {
        [styles.loading]: loading,
      })}
      // eslint-disable-next-line react/button-has-type
      type={type}
      disabled={disabled || loading}
      {...props}
    >
      <CloseIcon />
    </button>
  );
});
export default CloseButton;
